import { ReactNode } from "react";
import { useLayout } from "@/contexts/UseLayout";
import TemPermissao from "@/components/utils/NiveisDeAcesso";
import { SemPermissao } from "@/components/SemPermissao";

interface ProtectedRouteProps {
  children: ReactNode;
  recurso: string;
  permissao?: 'visualizar' | 'criar' | 'editar' | 'remover';
}

/**
 * Componente para proteger rotas baseado em permissões de acesso
 * @param children - Componente filho a ser renderizado se o usuário tiver permissão
 * @param recurso - Nome do recurso/módulo (ex: 'dashboard', 'desks', 'usuarios', etc.)
 * @param permissao - Tipo de permissão necessária (padrão: 'visualizar')
 */
export function ProtectedRoute({
  children,
  recurso,
  permissao = 'visualizar'
}: ProtectedRouteProps) {
  const { userLogged } = useLayout();

  // Aguarda o carregamento dos dados do usuário
  if (!userLogged?.data?.id) {
    return null;
  }

  // Admin tem acesso a tudo
  if (userLogged?.data?.is_admin) {
    return <>{children}</>;
  }

  // Verifica se o usuário tem a permissão necessária
  const temPermissao = TemPermissao(userLogged, recurso, permissao);

  if (!temPermissao) {
    return <SemPermissao />;
  }

  return <>{children}</>;
}
